import type { CustomFieldTypeValue } from '@awork/features/project/models/custom-field-type.model'
import type { DropdownOption } from '@awork/_shared/models/select-option.model'
import type { BadgeColor } from '@awork/_shared/types/color'

export type CustomFieldEntityType = 'task' | 'project'

export interface ICustomFieldDefinition {
  id: string
  name: string
  type: CustomFieldTypeValue
  entity: CustomFieldEntityType
  selectionOptions?: ICustomFieldSelectionOption[]
  linkedProjectIds?: string[]
  order?: number // Only for projects
  isExternal?: boolean
}

export interface ICustomFieldSelectionOption {
  id: string
  value: string
  color?: BadgeColor
  order: number
}

/**
 * Represents the custom field available in the Workspace.
 * In the case of type Select, it also has the possible selection values.
 */
export class CustomFieldDefinition implements ICustomFieldDefinition {
  id: string
  name: string
  type: CustomFieldTypeValue
  entity: CustomFieldEntityType
  selectionOptions?: ICustomFieldSelectionOption[]
  linkedProjectIds?: string[]
  order?: number
  isExternal?: boolean

  constructor(customFieldDefinition: Partial<ICustomFieldDefinition>) {
    Object.assign(this, customFieldDefinition)

    if (this.isExternal === undefined) {
      this.isExternal = false
    }
  }

  /**
   * Maps the selection options to DropdownOptions
   * @returns {DropdownOption[]}
   */
  get selectOptions(): DropdownOption[] {
    return this.selectionOptions
      ?.sort((a, b) => a.order - b.order)
      .map(value => ({ label: value.value, value: value.id, dotColor: value.color }))
  }
}
